// Axi is told to escape < and > as HTML (the same answers feed an HTML widget
// on the WordPress cards). PlainTextMath renders text, not HTML, so it decodes
// those entities first; React still escapes the result. Kept import-free so it
// runs under `node --test` (plain-text.test.mjs).
const ENTITIES: Record<string, string> = { lt: '<', gt: '>', amp: '&' }

// One pass, so "&amp;lt;" becomes the text "&lt;", not "<".
export const decodeTextEntities = (text: string): string =>
  text.replace(/&(lt|gt|amp);/g, (_, name: string) => ENTITIES[name])
